import { z } from 'zod'
const jsonObject = z.record(z.unknown())
export const tcpOtpSendResponseSchema = jsonObject
export const tcpOtpVerifyResponseSchema = jsonObject
export type TcpOtpSendResponse = z.infer<typeof tcpOtpSendResponseSchema>
export type TcpOtpVerifyResponse = z.infer<typeof tcpOtpVerifyResponseSchema>
